import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL + '/api/portal';
const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem('portalToken')}` } });

const getMe = () => axios.get(`${BASE}/me`, auth()).then(r => r.data.employee);

const getAgreement = () => axios.get(`${BASE}/driver/agreement`, auth()).then(r => r.data);
const signAgreement = (signatureDataUrl) => axios.post(`${BASE}/driver/agreement/sign`, { signatureDataUrl }, auth()).then(r => r.data);

const setAvailability = (isAvailableForDelivery) => axios.put(`${BASE}/driver/availability`, { isAvailableForDelivery }, auth()).then(r => r.data);
const getOffers = () => axios.get(`${BASE}/driver/offers`, auth()).then(r => r.data);
const getMyDeliveries = () => axios.get(`${BASE}/driver/deliveries`, auth()).then(r => r.data);

const acceptDelivery = (deliveryId, latitude, longitude) =>
  axios.post(`${BASE}/driver/deliveries/${deliveryId}/accept`, { latitude, longitude }, auth()).then(r => r.data.delivery);
const markPickedUp = (deliveryId) => axios.post(`${BASE}/driver/deliveries/${deliveryId}/picked-up`, {}, auth()).then(r => r.data.delivery);
const pingLocation = (latitude, longitude) => axios.post(`${BASE}/driver/location`, { latitude, longitude }, auth()).then(r => r.data);

const getVapidPublicKey = () => axios.get(`${process.env.REACT_APP_API_URL}/api/push/vapid-public-key`).then(r => r.data.publicKey);
const subscribePush = (subscription) => {
  const json = subscription.toJSON();
  return axios.post(`${BASE}/push/subscribe`, { endpoint: json.endpoint, keys: json.keys, userAgent: navigator.userAgent }, auth()).then(r => r.data);
};
const unsubscribePush = (endpoint) => axios.delete(`${BASE}/push/subscribe`, { ...auth(), data: { endpoint } }).then(r => r.data);

const driverPortalService = {
  getMe,
  getAgreement, signAgreement,
  setAvailability, getOffers, getMyDeliveries,
  acceptDelivery, markPickedUp, pingLocation,
  getVapidPublicKey, subscribePush, unsubscribePush,
};
export default driverPortalService;
